import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import CaseStudyDetailPage from './pages/CaseStudyDetailPage';
import MeetTheTeamPage from './pages/MeetTheTeamPage';
import BeamrPage from './pages/BeamrPage';
import Aboutmonkstack from './pages/Aboutmonkstack';
import ContactPage from './pages/ContactPage';
import CareersPage from './pages/CareersPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/case-studies/:slug" element={<CaseStudyDetailPage />} />
        <Route path="/meet-the-team" element={<MeetTheTeamPage />} />
        <Route path="/beamr" element={<BeamrPage />} />
        <Route path="/about-monkstack" element={<Aboutmonkstack />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:slug" element={<ProductDetailPage />} />
      </Routes>
    </>
  );
}

export default App;

